export const SERVER_CAPABILITIES = {
    plex: { mediaLibrary: true }, jellyfin: { mediaLibrary: true }, emby: { mediaLibrary: true }, dispatcharr: { mediaLibrary: false },
};
export function supportsMediaLibrary(type) { return SERVER_CAPABILITIES[type].mediaLibrary; }
//# sourceMappingURL=serverCapabilities.js.map